import React from "react";
import Layout from "../../components/Layout/Layout";
import RefundForm from "./RefundForm";

const RefundCancellation = () => {
  return (
    <>
      <Layout>
        <div className="bred_crumb blog_detail_bredcrumb">
          <div className="container">
            <div className="bred_text">
              <h1>Refund & Cancellation</h1>
            </div>
          </div>
        </div>

        <section className="blog_detail_section">
          <div className="container">
            <div className="blog_inner_pannel plan-cancel">
              <div className="container">
                <h4>Refund Policy</h4>
                <p className="mb-5">
                  You may request a refund within 30 days of your purchase.
                  <br />
                  After this period, refunds will not be issued.
                </p>
                <h4 className="mb-4">Request a Refund</h4>
                <RefundForm />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default RefundCancellation;
